
import Vue from 'vue';
import { namespace } from 'vuex-class';
import { Component, Emit, Prop } from 'vue-property-decorator';

import { isToday } from '@/helpers/date-helper';

const Language = namespace('language');

@Component({ name: 'DateChooser' })
export default class DateChooser extends Vue {
	@Prop({ required: true }) displayDate: Date;

	@Language.Getter locale: string;
	@Language.Getter language: string;

	get isToday() {
		return isToday(this.displayDate);
	}

	get dateDisplay() {
		if (this.isToday) {
			return this.$t('WEBAPP_TODAY');
		}

		const locale = (this.locale ?? 'en_US').replace('_', '-');
		const formatter = new Intl.DateTimeFormat(locale, { day: '2-digit', month: 'short' });

		return formatter.format(this.displayDate);
	}

	get pastDates() {
		let pastDates = [];
		for (let i = 1; i <= 3; i++) {
			const selectedDate = new Date(this.displayDate);
			const date = new Date(selectedDate);
			date.setDate(date.getDate() - i);
			pastDates.push({ date: date, shift: -Math.abs(i) });
		}
		return pastDates;
	}

	get futureDates() {
		let futureDates = [];
		for (let i = 1; i <= 3; i++) {
			const selectedDate = new Date(this.displayDate);
			const date = new Date(selectedDate);
			date.setDate(date.getDate() + i);
			futureDates.push({ date: date, shift: Math.abs(i) });
		}
		return futureDates;
	}

	getWeekday(date: Date) {
		return new Intl.DateTimeFormat(this.language, {
			weekday: 'short',
		}).format(date);
	}

	getDate(date: Date) {
		return new Intl.DateTimeFormat(this.language, {
			day: 'numeric',
			month: 'short',
		}).format(date);
	}

	@Emit('return')
	handleReturnClick() {}

	@Emit('next')
	handleClickNext() {}

	@Emit('prev')
	handleClickPrev() {}

	@Emit('date')
	handleClickDate(shift: number) {
		return shift;
	}
}
